import Loader from "react-loader-spinner";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { useHistory } from "react-router-dom";
import { Card, Col, Row } from "react-bootstrap";
import BihamtaTable from "../../Components/BihamtaTable";
import { getDefinedServiceCostDetailed } from "../store/api/Services";
import { FileEarmarkExcelFill, PrinterFill } from "react-bootstrap-icons";
import { exportToExcel } from "../../store/api/CommonFunctions";
import { useParams } from "react-router-dom";

const DefinedServiceCostDetailedReport = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {id} = useParams();
    const { parentFilterData, filterData, settings, dataList } = useSelector(state => {
        return {
            parentFilterData: state.service.defServCostsAggFilters,
            filterData: state.service.defServCostsDtlFilters,
            settings: state.SystemSettingsReducer.systemSettings,
            dataList: state.service.defServCostsDetailed
        }
    });
    const [pending, setPending] = useState(false);
    const firstDef =Array.isArray(dataList?.Data)? dataList.Data[0]:{};
    const settingNames = ['ProductGrouppingType'];
    const pgType = Array.isArray(settings) && settings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", justInMobile: true },
        // { colName: "ItemCode", colTitle: "کد تعرفه", justInMobile: true },
        // { colName: "ItemDesc", colTitle: "شرح تعرفه", justInMobile: true },
        { colName: "IsGarauntee", colTitle: "گارانتی", colType: "boolean" },
        { colName: "ServiceCount", colTitle: "تعداد" },
        { colName: "ServiceCost", colTitle: "مبلغ واحد", colType: "currency" },
        { colName: "ServiceTotalCost", colTitle: "مبلغ کل", colType: "currency" },
        { colName: "RowDiscount", colTitle: "تخفیف", colType: "currency" },
        { colName: "TaxAmount", colTitle: "مالیات", colType: "currency" },
        { colName: "ServiceFinalTotalCost", colTitle: "جمع خالص", colType: "currency" },
        { colName: "StaffShare", colTitle: "سهم تکنسین", colType: "currency" },
        { colName: "PFirstContactDate", colTitle: "تاریخ پذیرش" },
        { colName: "PServiceType", colTitle: "نوع" },
        { colName: "InvoiceNumber", colTitle: "شماره سرویس" },
        { colName: "HolderName", colTitle: "مارک محصول", showConditionn: () => pgType !== 1 },
        { colName: "ProductName", colTitle: (pgType === 1 ? "نام" : "نوع") + " محصول" },
        { colName: "ProductModel", colTitle: "مدل محصول" },
        { colName: "ProductSerial", colTitle: "سریال محصول", style:{fontFamily:"Dark-Sans", fontSize:"11.5px"} },
        { colName: "StaffName", colTitle: "نام تکنسین" },
        { colName: "AgencyName", colTitle: "نمایندگی" },
        { colName: "ReceptionInAgent", colTitle: "پذیرش در نمایندگی", colType: "boolean" }
    ]
    function toExcel() {
        const url = `api/ServiceReportsAPI/GetDefinedServiceCostDetailed`;
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        setPending(true);
        exportToExcel("DefinedServiceCostDetailed", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/DefinedServiceCostDetailed/${e.ctrlKey}`,
            state: {
                dataUrl: `api/ServiceReportsAPI/GetDefinedServiceCostDetailed`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function search() {
        const data = { ...parentFilterData }
        data.Skip = 0;
        data.DefinedIDs = [id];
        dispatch(getDefinedServiceCostDetailed(data));

    }
    useEffect(() => {
        dispatch(getSystemSettings(settingNames));
        document.body.classList = "notMain";
        search();
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
            </Card>
            <Card.Header className="headerStyle">
                گزارش ریز خدمات و تعرفه ها
            </Card.Header>
            <Card.Body className="bodyStyle">
                <div style={{textAlign:"right"}}>
                    <label>کد تعرفه: </label>
                    <label  style={{fontWeight:"bold"}}>{firstDef.ItemCode ?? ""}</label>
                </div>
                <div style={{textAlign:"right"}}>
                    <label>شرح تعرفه: </label>
                    <label style={{fontWeight:"bold"}}>{firstDef.ItemDesc ?? ""}</label>
                </div>
                {!pending &&
                    <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                        <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                    </div>}
                {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                <BihamtaTable columns={tableCols} reducerName="service" objectName="defServCostsDetailed" searchMethod={(data) => dispatch(getDefinedServiceCostDetailed(data))} fixedHeight
                    style={{ whiteSpace: "nowrap" }} className="mt-0 mb-0" />
            </Card.Body>
        </div>
    )
}
export default DefinedServiceCostDetailedReport;